export default __webpack_public_path__ + "static/illustration-content-desc.url-57f84d1190c6f48fd8e7ea2c78ea9ec0.svg";